module.exports = __webpack_public_path__ + "static/media/dexipo.2b586168.jpg";